
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Chart from '../../mixins/Chart.vue'
import { Dataset, Options } from '../../@types/Slide'
import ChartDataLabels from 'chartjs-plugin-datalabels'

@Component
export default class Line extends Mixins<Chart>(Chart) {
  /**
   * Chart type.
   */
  public readonly chartType: string = 'line'
  public plugins = [ChartDataLabels]
}
